// extracted by mini-css-extract-plugin
export default {"folderName":"hsxIei93gX"};